import styled from "styled-components";


export const MeetingActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  margin-top: 10px;
`;

export const MeetingActionButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
`;

